export default "__VITE_ASSET__f65fbd05__"